import { formatDate, formatDateTime } from '../lib/format'

/** A date; hovering shows the exact time, to the second. */
export default function Timestamp({ value }: { value: string }) {
  return (
    <time dateTime={value} title={formatDateTime(value)}>
      {formatDate(value)}
    </time>
  )
}
